import { useEffect, useState } from "react";
import { Button, Checkbox, CheckboxGroup, Stack, Text, Wrap, WrapItem, useToast } from "@chakra-ui/react";
import { useAuth } from "../../auth/hooks/useAuth";
import { apiErrorMessage } from "../../../shared/api/apiErrorMessage";
import { useShiftRemindersQuery, useUpdateShiftRemindersMutation } from "../hooks/useShiftReminders";

const LEAD_OPTIONS = [
  { hours: 1, label: "1 hora antes" },
  { hours: 4, label: "4 horas antes" },
  { hours: 6, label: "6 horas antes" },
  { hours: 12, label: "12 horas antes" },
  { hours: 24, label: "24 horas antes" },
];

// "Lembretes de plantão": o médico escolhe com quanta antecedência quer ser avisado por
// e-mail (opt-in — nada marcado por padrão). O envio é o job horário `reminders shifts`.
export default function ShiftRemindersSection() {
  const toast = useToast();
  const { user } = useAuth();
  const query = useShiftRemindersQuery();
  const mutation = useUpdateShiftRemindersMutation();
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (query.data) setSelected(query.data.lead_hours.map(String));
  }, [query.data]);

  // Mesmo destino que o job usa: sempre o e-mail de login. O "e-mail de notificação" do
  // perfil é o do RH/contratante (comprovação), não recebe lembrete.
  const destino = user?.email;

  const handleSave = () => {
    mutation.mutate(selected.map(Number), {
      onSuccess: (dados) =>
        toast({
          title: dados.lead_hours.length ? "Lembretes de plantão salvos" : "Lembretes de plantão desligados",
          status: "success",
          duration: 4000,
        }),
      onError: (error) =>
        toast({
          title: "Não foi possível salvar os lembretes",
          description: apiErrorMessage(error),
          status: "error",
          duration: 5000,
          isClosable: true,
        }),
    });
  };

  return (
    <Stack spacing={4}>
      <Text fontSize="sm" color="app-muted-fg">
        Escolha com quanta antecedência quer ser lembrado de cada plantão.
        {destino ? (
          <>
            {" "}Enviamos por e-mail para <strong>{destino}</strong>.
          </>
        ) : (
          " Enviamos por e-mail."
        )}
      </Text>

      {/* Sem a escolha salva, caixas desmarcadas se leriam como "nenhum lembrete" — e
          salvar ali apagaria a escolha de verdade. */}
      {query.isError ? (
        <Stack spacing={2} align="flex-start">
          <Text fontSize="sm">Não foi possível carregar seus lembretes.</Text>
          <Button size="sm" variant="outline" onClick={() => query.refetch()} isLoading={query.isFetching}>
            Tentar de novo
          </Button>
        </Stack>
      ) : (
        <>
          <CheckboxGroup value={selected} onChange={setSelected}>
            <Wrap spacing={4}>
              {LEAD_OPTIONS.map((o) => (
                <WrapItem key={o.hours}>
                  <Checkbox value={String(o.hours)} isDisabled={query.isLoading}>
                    {o.label}
                  </Checkbox>
                </WrapItem>
              ))}
            </Wrap>
          </CheckboxGroup>

          <Text fontSize="xs" color="app-muted-fg">
            Plantões sem horário recebem um lembrete na véspera, às 18h. Plantões cancelados ou que já começaram não
            recebem lembrete.
          </Text>

          <Button
            size="sm"
            alignSelf="flex-start"
            onClick={handleSave}
            isLoading={mutation.isPending}
            isDisabled={query.isLoading}
          >
            Salvar lembretes
          </Button>
        </>
      )}
    </Stack>
  );
}
